import AS2 from "./src/AS2.vue";
import AS3 from "./src/AS3.vue";
import DIR from "./src/DIR.vue";
import FTP from "./src/FTP.vue";
import FTPS from "./src/FTPS.vue";
import RCTMQ from "./src/RCTMQ.vue";
import RMQ from "./src/RMQ.vue";
import SFTP from "./src/SFTP.vue";
import SOAP from "./src/SOAP.vue";
import WMQ from "./src/WMQ.vue";
import REST from './src/REST.vue'
import AMQ from './src/AMQ.vue';
import RocketMQ from './src/RocketMQ'
export default {
    AS2,
    AS3,
    DIR,
    FTP,
    FTPS,
    RCTMQ,
    RMQ,
    SFTP,
    SOAP,
    WMQ,
    REST,
    AMQ,
    RocketMQ
};

